import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'siat-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
   
  imports: [
    MatMenuModule,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatTooltip,
    TranslatePipe,
  ],
})
export class LanguageSwitcherComponent implements OnInit {
  languages;
  currentLanguage = signal<string | undefined>(undefined);
  translateService = inject(TranslateService);

  ngOnInit(): void {
    this.currentLanguage.set(this.translateService.getCurrentLang());
    this.languages = this.translateService.getLangs();
    this.translateService.onLangChange.subscribe(event => {
      this.currentLanguage.set(event.lang);
    });
  }

  setLaguage(lang: string) {
    this.translateService.use(lang);
  }
}
